import { useTranslate } from "@made-people/grease-translations";
import { TrustpilotLogo } from "../../assets/icons/TrustpilotLogo";
import { useTrustpilotAverageRating } from "@made-people/grease-trustpilot";

export const TopbarTrustpilot = () => {
  const translate = useTranslate();
  const storeAverageRating = useTrustpilotAverageRating("store");

  return (
    <span className="flex items-center justify-center gap-1.5 text-body-xs lg:text-body-sm">
      <span>
        {translate("Topbar_Trustpilot_Text", {
          score: storeAverageRating,
          max: "5",
        })}
      </span>
      <TrustpilotLogo className="h-3.5 lg:h-4 w-auto" />
    </span>
  );
};
